import * as React from 'react';
export const AGSvg = React.forwardRef(function AGSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M1.994 0A1.992 1.992 0 0 0 0 2v2h16V2c0-1.105-.895-2-1.994-2H1.994Z',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: 8,
        cy: 4,
        r: 3,
        fill: '#FCD669',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#45B2E8',
        d: 'M0 4h16v3H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M0 7v2a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M7.253 11.16 0 3v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3l-7.253 8.16a1 1 0 0 1-1.494 0Z',
      }),
    ),
  );
});
AGSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var AG = {
  category: 'flag',
  colorable: false,
  name: 'AG',
  svg: AGSvg,
};
